import { ReactElement } from 'react'

export type AnnuityElement = {
  text: ReactElement
  action: () => void
}
